import styled from 'styled-components';

export const Header = styled.header`
  border-bottom: 1px solid black;
  padding: 20px 0px;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  justify-content: space-between;
  padding: 0 20px;
`;

export const UnstableNav = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
